import { ActionTypes, TLayout, TView, TActionTypes } from './types'

/**
 * @function setHeaderInfo
 * @param payload
 */
function change(payload: TView): TActionTypes {
  sessionStorage.setItem('current_view', JSON.stringify(payload))

  return {
    type: ActionTypes.VIEW_CHANGE,
    payload,
  }
}

/**
 * @function setHeaderInfo
 * @param payload
 */
function changeLayout(payload: TLayout): TActionTypes {
  return {
    type: ActionTypes.VIEW_CHANGE_LAYOUT,
    payload,
  }
}

/**
 * @function removeData
 */
function removeData(): TActionTypes {
  sessionStorage.removeItem('current_view')

  return {
    type: ActionTypes.VIEW_REMOVE_DATA,
  }
}

export default {
  change,
  changeLayout,
  removeData,
}
